import Vue from 'vue'
import VueRouter from 'vue-router'


// 导入视图组件
import HomeView from '@/views/Home.vue'
import AboutView from '@/views/About.vue'
import ProductsView from '@/views/Products.vue'
import ResearchView from '@/views/Research.vue'
import NewsView from '@/views/News.vue'
import LoginView from '@/views/Login.vue'
import RegisterView from '@/views/Register.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/about', name: 'about', component: AboutView },
  { path: '/products', name: 'products', component: ProductsView },
  { path: '/research', name: 'research', component: ResearchView },
  { path: '/news', name: 'news', component: NewsView },
  { path: '/news/:id', name: 'news-detail', component: () => import('@/views/NewsDetail.vue') },
  { path: '/login', name: 'login', component: LoginView },
  { path: '/register', name: 'register', component: RegisterView },
  { path: '/admin', name: 'admin', component: () => import('@/views/Admin.vue'), meta: { requiresAuth: true } }
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash', // 改为hash模式以支持静态网站部署
  routes,
  scrollBehavior() { return { x:0, y:0 } }
})

// 添加导航守卫，实现JWT认证和角色权限控制
router.beforeEach(async (to, from, next) => {
  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查localStorage中是否有token
    const token = localStorage.getItem('token')
    if (!token) {
      // 没有token，重定向到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 保存当前路由，登录后跳转回来
      })
    } else {
      // 有token，检查用户角色权限
      try {
        // 导入authAPI
        const { authAPI } = await import('@/services/api')
        const userData = await authAPI.getCurrentUser()
        if (userData.success) {
          const user = userData.data
          const roles = user.roles || []
          const roleNames = roles.map(role => role.name)
          
          // 检查是否访问管理后台
          if (to.path === '/admin') {
            // 只有admin或editor角色可以访问管理后台
            if (roleNames.includes('admin') || roleNames.includes('editor')) {
              next()
            } else {
              // 没有权限，重定向到首页
              next({ path: '/' })
            }
          } else {
            // 其他需要认证的路由，允许访问
            next()
          }
        } else {
          // 获取用户信息失败，清除token并重定向到登录页
          localStorage.removeItem('token')
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      } catch (error) {
        console.error('权限检查失败:', error)
        // 发生错误，清除token并重定向到登录页
        localStorage.removeItem('token')
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    }
  } else {
    // 不需要认证的路由，直接通过
    next()
  }
})

export default router